import React from "react";
import {
    auth,
    GoogleAuthProvider,
    signInWithPopup,
} from "../services/firebase";
import { useNavigate } from "react-router-dom";
import { FaGoogle } from "react-icons/fa";
import "./Signin.scss";

const SignIn = () => {
    const navigate = useNavigate();
    const signInWithGoogle = async () => {
        try {
            const provider = new GoogleAuthProvider(); // Note: You don't use 'new' with modular SDK
            const result = await signInWithPopup(auth, provider);
            navigate("/profile");
            return result.user;
        } catch (error) {
            console.error("Error signing in with Google:", error);
        }
    };

    return (
        <div className="signin layout">
            <button onClick={signInWithGoogle}>
                <FaGoogle />
                <span>Sign In with Google</span>
            </button>
        </div>
    );
};

export default SignIn;
